<template>
  <div>
    <b-row>
      <b-col>
        <md-field :class="{'md-invalid': fullNameErr}" class="moow-input">
          <label>Full Name</label>
          <md-input v-model="fullName" :readonly="nameReadOnly"></md-input>
          <span class="md-error">{{fullNameErr}}</span>
        </md-field>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <md-field :class="{'md-invalid': emailErr}" class="moow-input">
          <label>Email</label>
          <md-input v-model="email" :readonly="emailReadOnly"></md-input>
          <span class="md-error">{{emailErr}}</span>
        </md-field>
        <md-field :class="{'md-invalid': passwordErr}" class="moow-input">
          <label>Password</label>
          <md-input v-model="password" type="password"></md-input>
          <span class="md-error">{{passwordErr}}</span>
        </md-field>
      </b-col>
    </b-row>

    <b-row class="mb-3" style="cursor:pointer;">
      <b-col @click="openTermsDialog">
        <md-checkbox v-model="agreed" class="md-primary">
          <a>I agree with terms and condition</a>
        </md-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <md-button class="md-raised md-primary play-cta-button makeup fill" @click="register()">Continue</md-button>
    </b-row>
    <md-dialog :md-active="showTerms">
      <terms-conditions @makeDecision="closeTermsDialog" :requireBottom="false"></terms-conditions>
    </md-dialog>
    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>
<script>
import TermsAndConditions from "@/components/dialogs/TermsAndConditions.vue";
import UserCreationDecorator from "@/platform/auth/services/UserCreationDecorator.js";
import {generateRandomWord} from "@/utils/other/services/randomnessGenerator.js"
export default {
  name: "loginForm",
  props: {
    inviterUidForced: {
      type: String,
      required: false
    },
    emailForced: {
      type: String,
      required: false
    },
    accountIdForced: {
      type: String,
      required: false
    },
    inviteeRole: {
      type: String,
      required: false
    },
    invitedToDealId: {
      type: String,
      required: false
    },
    nameForced:{
      type: String,
      required: false
    },
    userRole: {
      type: String,
      required: false
    }
  },
  components: {
    "terms-conditions": TermsAndConditions
  },
  data() {
    return {
      showTerms: false,
      showSnackbar: false,
      snackbarMessage: "",
      selected: false,
      name: "",
      password: "",
      email: "",
      areaCode: "",
      phoneNumber: "",
      fullName: "",
      agreed: false,
      indeterminate: true,
      loadingText: "",
      important: "required|alpha",
      rules: {
        emailRule: /.+@.+/,
        includeLetterRule: /[a-z]/,
        includeNumberRule: /\d/
      },
      emailErr: "",
      passwordErr: "",
      lastNameErr: "",
      firstNameErr: "",
      fullNameErr: ""
    };
  },
  watch: {
    fullName: function(val, oldVal) {
      if (!val) this.fullNameErr = "Required";
      else this.fullNameErr = "";
    },
    email: function(val, oldVal) {
      if (val && val != oldVal) {
        if (this.rules.emailRule.test(val)) this.emailErr = "";
        else this.emailErr = "Invalid email";
      } else this.emailErr = "Required";
    },
    password: function(val, oldVal) {
      if (!val) this.passwordErr = "Required";
      else if (val.length <= 6) this.passwordErr = "Min 6 characters";
      else if (!this.rules.includeLetterRule.test(val))
        this.passwordErr = "Must include a letter";
      else if (!this.rules.includeNumberRule.test(val))
        this.passwordErr = "Must include a number";
      else this.passwordErr = "";
    }
  },
  computed: {
    emailReadOnly() {
      if (this.emailForced) return true;
      else return false;
    },
    nameReadOnly(){
      if (this.nameForced) return true;
      else return false;
    }
  },
  created() {
    if (process.env.NODE_ENV == "development") {
      let firstName = generateRandomWord()
      this.fullName = firstName + " " + generateRandomWord()
      this.password = "maaklerrelkaam10"
      this.email = firstName + "@moowle.com"
      this.agreed = true
    }
  },
  mounted() {
    document.addEventListener("keyup", this.keyPressAction);
    if (this.emailForced) this.email = this.emailForced;
    if(this.nameForced) this.fullName = this.nameForced;
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.keyPressAction);
  },
  methods: {

    keyPressAction(keyCode) {
      switch (keyCode.code) {
        case "Enter":
          this.register();
          break;
      }
    },
    openTermsDialog() {
      this.showTerms = true;
      this.agreed = false;
    },
    closeTermsDialog(decision) {
      this.showTerms = false;
      this.agreed = decision;
    },
    async register() {
      try{
        if(this.validateForm()){
          this.$emit("emitLoading", true);
          this.$store.commit("IS_LOADING_USER", true);
          sessionStorage.setItem("user_just_registered", true); // this tells firebase auth listener not to load user from our system upom auth state chage (instead its delegated to the this.setupUserForLogin())
          
          const userCreationDecorator = new UserCreationDecorator({
            authMethod: {email: this.email, password: this.password}, 
            attributes: this.aggregateUserAttributes() 
          })
          const result = await userCreationDecorator.create()
          if(!result.success) throw {message: result.message, expected: result.expected}

          if (!result.authUser.emailVerified) {
            this.snackbarMessage = "Check your email for verification link!";
            this.showSnackbar = true;
          }

          this.$emit("emitSuccessfulRegistration");
        }
      }catch(ex){
        this.handleUserCreationError(ex);
        this.$emit("emitFailedRegistration", ex);
      }
    },
    aggregateUserAttributes(){
      return {
        fullName: this.fullName, 
        additionalAttributes:  {
          accountIdForced: this.accountIdForced,
          inviteeRole: this.inviteeRole,
          inviterUidForced: this.inviterUidForced,
          invitedToDealId: this.invitedToDealId,
          userRole: this.userRole
        }
      }
    },
    handleUserCreationError(error) {
      if(error && error.expected){
        this.snackbarMessage = error.message
        this.emailErr = error.message
      }else{
        this.snackbarMessage = "Something is not right, our team has been notified";
      }
  
      this.showSnackbar = true;
      this.$store.dispatch("logout");
    },
    validateForm() {
      var res = true;
      if (!this.password) {
        this.passwordErr = "Required";
        res = false;
      }
      if (!this.email || !this.rules.emailRule.test(this.email)) {
        this.emailErr = "Invalid";
        res = false;
      }
      if (!this.fullName) {
        this.fullNameErr = "Required";
        res = false;
        return false;
      }
      var nps = this.fullName.split(" ");
      if (nps.length < 2 || !nps[1]) {
        this.fullNameErr = "Use your full name";
        res = false;
      }

      if (!this.agreed){
        res = false
        this.snackUser("Accept Terms & Conditions to proceed");
      } 

      return res;
    },
    // googleRegister() {
      //...check version control for historic implementation
    // },
    snackUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

.line {
  display: inline-block;
  vertical-align: middle;
  zoom: 1;
  width: 100%;
  border: 1px solid #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/registerForm.vue